import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RequiresPermissionsModule } from '../../directives/requires-permissions/requires-permissions.module';
import { TripNotesDetailModule } from '../../trip-notes-detail/trip-notes-detail.module';
import { TripNotesDialogComponent } from './trip-notes-dialog.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatDialogModule, MatButtonModule, MatListModule, RequiresPermissionsModule, TripNotesDetailModule],
  exports: [TripNotesDialogComponent],
  declarations: [TripNotesDialogComponent]
})
export class TripNotesDialogModule {}
